import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

// Create Branch
export const createBranch = async (data: any) => {
	const URL = `${API_URL}CreateBranch`;
	const requestData = {
		BranchCreateToken: data,
	};
	return makeApiCall(URL, requestData);
};

// Update Branch
export const updateBranch = async (data: any) => {
	const URL = `${API_URL}UpdateBranch`;
	const requestData = {
		BranchUpdateToken: data,
	};
	return makeApiCall(URL, requestData);
};

// Get Branches By Organisation
export const getBranchesByOrganisation = async (data: any) => {
	const requestData = {
		BranchDetailsToken: data,
	};
	if (process.env.NODE_ENV === 'development') console.log('requestData', requestData);
	return makeApiCall(`${API_URL}GetBranchesByOrganisation`, requestData);
};

export const getBranchById = async (data: any) => {
	const requestData = {
		getBranchByIdToken: data,
	};
	const URL = `${API_URL}GetBranchDetailsByBranchID`;
	return makeApiCall(URL, requestData);
};
